import { useMutation, useQuery } from "react-query";
import { fetchItem, postItem } from "../queries/queries-helper.ts";
import ENDPOINTS from "../services/endpoints.ts";
import ResponseApi from "../models/interfaces/response-api.ts";
import { JobCreatedDto } from "../models/interfaces/dtos/production/job-created-dto.ts";
import JobDto from "../models/interfaces/dtos/production/job-dto.ts";
import useProjectContext from "../services/context/project/use-project-context.ts";

const useProjectAccess = (projectId: string) => {
    const { project } = useProjectContext();
    
    const currentRevision = project.baamerRevisionId;

    const accessQueryResult = useQuery(
        ["project-access", projectId],
        async () => fetchItem<boolean>(
            ENDPOINTS.BOOMER_PROJECT_CAN_POST(projectId),
        ),
    );

    const canPost = accessQueryResult.data;

    const baamerRevisionQueryResult = useQuery(
        ["baamer-revision-post", currentRevision],
        async () => fetchItem<boolean>(ENDPOINTS.BOOMER_BAAMER_REVISION_POSTED(currentRevision || "")),
        {
            enabled: !!canPost && canPost,
        },
    );

    const launchNewRevision = useMutation({
        mutationFn: () => postItem<ResponseApi<JobCreatedDto>>(ENDPOINTS.REVISION_LAUNCH_NEW(projectId || ""),
        ),
    });

    const getLaunchNewRevisionStatus = useMutation({
        mutationFn: (jobId: string) => fetchItem<JobCreatedDto>(ENDPOINTS.REVISION_GET_NEW_REVISION_STATUS(jobId || "")),
    });

    const launchProcess = useMutation({
        mutationFn: (processName: string) => postItem<ResponseApi<JobCreatedDto>>(ENDPOINTS.PRODUCTION_LAUNCH_PROCESS(projectId || "", processName, false)),
    });

    const getLaunchProcessStatus = useMutation({
        mutationFn: (jobId: string) => fetchItem<JobDto>(ENDPOINTS.PRODUCTION_GET_JOB_STATUS(jobId || "")),
    });

    const launchPostRevision = useMutation({
        mutationFn: (newBoomerRevision: boolean) => postItem<ResponseApi<JobDto>>(
            ENDPOINTS.BOOMER_LAUNCH_POST_REVISION(projectId || ""),
            {
                projectBoomerId: project.projectBoomerId,
                newBoomerRevision: newBoomerRevision
            }
        ),
    });

    const getPostRevisionStatus = useMutation({
        mutationFn: (jobId: string) => fetchItem<JobDto>(ENDPOINTS.BOOMER_GET_POST_REVISION_STATUS(jobId || "")),
    });

    return {
        accessQueryResult,
        baamerRevisionQueryResult,
        launchNewRevision,
        getLaunchNewRevisionStatus,
        launchProcess,
        getLaunchProcessStatus,
        launchPostRevision,
        getPostRevisionStatus,
    };
};

export default useProjectAccess;